import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const expandRow = createAsyncThunk('orderhistory__UI_expandRow', async (params) => {
    return params;
});


const initialState = {
    expandArray: [],
    selected_fields: {}
};
const slice = createSlice({
    name: "OrderHistory__UI",
    initialState: initialState,
    reducers: {
        load_all_selected_fields: {
            reducer: (state, action) => {
                state.selected_fields = action.payload.selected_fields;
            },
        },
        load_initialState: {
            reducer: (state, action) => {
                state = action.payload;
                if (action.payload.selected_fields === undefined) {
                    state.selected_fields = {};
                }
                return state;
            },
        },
        remove_all_selected_fields: {
            reducer: (state, action) => {
                state.selected_fields = {};
            },
        },
        toggle_single_selected_fields: {
            reducer: (state, action) => {
                if (state.selected_fields[action.payload.uniqueNumber] !== undefined) {
                    if (action.payload.forceAdd === true) {
                        delete state.selected_fields[action.payload.uniqueNumber];
                        state.selected_fields[action.payload.uniqueNumber] = action.payload;
                    } else {
                        delete state.selected_fields[action.payload.uniqueNumber];
                    }

                } else {
                    if (action.payload.forceAdd === true) {
                        delete state.selected_fields[action.payload.uniqueNumber];
                    } else {
                        state.selected_fields[action.payload.uniqueNumber] = action.payload;
                    }
                    // if (state.selected_fields[action.payload.bomDetailId] === undefined) {
                    //     state.selected_fields[action.payload.bomDetailId] = action.payload;
                    // }
                }
            },
        },
        remove_single_selected_fields: {
            reducer: (state, action) => {
                if (state.selected_fields[action.payload.uniqueNumber] !== undefined) {
                    delete state.selected_fields[action.payload.uniqueNumber];
                }
            },
        },
    },
    extraReducers: {
        [expandRow.fulfilled]: (state, { payload }) => {
            if (payload === 'reset') {
                state.expandArray = []
            } else {
                state.expandArray != null && state.expandArray != undefined && state.expandArray.includes(payload) && state.expandArray.indexOf(payload) > -1 ?
                    state.expandArray.splice(state.expandArray.indexOf(payload), 1) : state.expandArray.push(payload);
            }

            return state;
        }
    },
});

export let { load_all_selected_fields,
    remove_all_selected_fields,
    toggle_single_selected_fields,
    load_initialState,
    remove_single_selected_fields } = slice.actions;

export default slice.reducer;
